import { colors } from "../../styles/colors";
import { fonts, fontSizes } from "../../styles/fonts";

export const cardView = {
    padding: 20,
    borderRadius: 10,
    backgroundColor: '#ffffff',
    boxShadow: '0 6px 10px 0 rgba(151, 196, 246, 0.19)',
    width: '100%'
}

export const header = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '14px'
}

export const cardTitle = {
    fontSize: fontSizes.medium,
    fontFamily: fonts.boldFont,
    color: colors.lightBlackishGrey,
}